import React, { useEffect, useState, Fragment } from 'react';
import { connect } from 'react-redux';
import Select from 'react-select';
import { OverlayTrigger, Popover } from 'react-bootstrap';
import { toast } from 'react-toastify';
import moment from 'moment-timezone';
// import 'bootstrap/dist/css/bootstrap.min.css';
import './css/LightGrid.css';
import { Form } from 'react-bootstrap';
import OtpInput from 'react-otp-input';
import InfoIcon from './img/info-icon.svg';
import deviceIconWhite from './img/device-name-icon-white.svg';
import buldingIconWhite from './img/building-icon-white.svg';
import SelectDeviceImage from './img/please-select-device.png';
import NoDataImage from './img/lcs-no-data.png';
import timingIconWhite from './img/timing-icon-white.svg';
import AcIdIconWhite from './img/account-id-icon-white.svg';
import LastUpdatedIcon from './img/last-updated-icon.svg';
import ConnectedIcon from './img/connected-cion.svg';
import LocationIcon from './img/location-icon.svg';
import CloseModalcon from './img/close-modal-icon.svg';
import LightGridIcon from './img/lightgrid-icon.png';
import firebaseApp from '../../Config/firebaseConfig';
import { dataUser, spocLocationDetailsZoho } from '../Helpers/util';
// import Tooltip from 'react-bootstrap/Tooltip';
import { Tooltip } from 'antd';
import {
  getDatabase,
  ref,
  onValue,
  get,
  onChildChanged,
} from 'firebase/database';
import axios from 'axios';
import SwSelect from '../Common/SwReactSelect/SwReactSelect';
const userDataLocal = dataUser();
var UserObj = JSON.parse(userDataLocal);

function LightGrid() {
  const [effectiveAtOff, setEffectiveAtOff] = useState('');
  const [countdown, setCountdown] = useState(60);
  const [countdowns, setCountdowns] = useState({
    edit: 60,
    delete: 60,
    lightOpen: 60,
    lightOff: 60,
    turnOff: 60,
    turnOn: 60,
  });

  const [resendAvailable, setResendAvailable] = useState(false);
  const [data1, setData1] = useState({});
  const [timeOptions1, setTimeOptions1] = useState([]);
  const [effectiveEndTime, setEffectiveEndTime] = useState('');
  const [isScheduleEdit, setIsScheduleEdit] = useState(false);
  const [bookingId, setBookingId] = useState('');
  const [selectedDeviceData, setSelectedDeviceData] = useState(null);
  const [fetchLcsData, setFetchLcsData] = useState([]);
  const [isLightsOff, setIsLightsOff] = useState(false);
  const [selectedOption, setSelectedOption] = useState('on');
  const [startTime, setStartTime] = useState('');
  const [endTime, setEndTime] = useState('');
  const [otp, setOtp] = useState('');
  const [iotId, setIotId] = useState('');
  const [isOtpSectionVisible, setIsOtpSectionVisible] = useState(false);
  const [
    isScheduleHoursModalVisible,
    setIsScheduleHoursModalVisible,
  ] = useState(true);
  const [isLightsOpen, setIsLightsOpen] = useState(false);

  const [isTogglePowerOn, setIsTogglePowerOn] = useState(false);
  const [isTogglePowerOff, setIsTogglePowerOff] = useState(false);
  const [isScheduleOpen, setIsScheduleOpen] = useState(false);
  const [todayWorkingTime, setTodayWorkingTime] = useState({});
  const [previousDayData, setPreviousDayData] = useState();
  const [locationData, setLocationData] = useState([]);
  const [selectedDevice, setSelectedDevice] = useState(null);
  const [selectedDeviceId, setSelectedDeviceId] = useState('');
  const [selectedLocation, setSelectedLocation] = useState(null);
  const [locationId, setLocationId] = useState(null);
  const [firebaseData, setFirebaseData] = useState(null);
  const [floorSpoc, setFloorSpoc] = useState([]);
  const [location2, setLocation2] = useState('');
  const [isDeleteModalVisible, setIsDeleteModalVisible] = useState(false);
  const [isDeleteOtpVisible, setIsDeleteOtpVisible] = useState(false);
  const [dateOptions, setDateOptions] = useState([]);
  const [selectedDate, setSelectedDate] = useState(null);
  const [loading, setLoading] = useState(true);
  const [timeEntries, setTimeEntries] = useState([]);
  const [addedHours, setAddedHours] = useState([]);
  const [editStartEndTime, setEditStartEndTime] = useState(null);
  const [editStartValue, setEditStartValue] = useState('');
  const [editEndValue, setEditEndValue] = useState('');
  const [allLocationStatusTrue, setAlLocationStatusTrue] = useState(true);
  const [timeOptions, setTimeOptions] = useState([]);
  const [selectedTime, setSelectedTime] = useState('');
  const userId = UserObj?.rec_id;
  const currentDateHideShow = new Date().toLocaleDateString();
  const selectedDateValue = new Date(selectedDate?.value).toLocaleDateString();
  const [filteredBookingData, setFilteredBookingData] = useState([]);

  const laterOff = e => {
    setSelectedOption(e.target.value);
    setEffectiveEndTime(todayWorkingTime?.endTime);
    const options = generateTimeOptions1();
    setTimeOptions1(options);
  };

  const formatTimeTo24Hrs = time => {
    if (typeof time === 'string') {
      const timeObj = moment(time, ['h:mm A']);
      return timeObj.format('HH:mm');
    } else if (time instanceof Date && !isNaN(time.getTime())) {
      const hours = time.getHours();
      const minutes = time.getMinutes();
      return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(
        2,
        '0',
      )}`;
    } else {
      return '00:00';
    }
  };

  function generateTimeOptions1() {
    const endTimeIST = moment
      .utc(effectiveEndTime)
      .tz('Asia/Kolkata')
      .subtract(15, 'minutes');
    let nowIST = moment()
      .tz('Asia/Kolkata')
      .add(15, 'minutes');
    const remainder = nowIST.minute() % 15;
    if (remainder !== 0) {
      nowIST.add(15 - remainder, 'minutes');
    }
    const extractTime = momentObj => ({
      hours: momentObj.hours(),
      minutes: momentObj.minutes(),
    });

    const nowTime = extractTime(nowIST);
    const endTime = extractTime(endTimeIST);
    const timeSlots = [];
    while (
      nowTime.hours < endTime.hours ||
      (nowTime.hours === endTime.hours && nowTime.minutes < endTime.minutes)
    ) {
      const hours = nowIST.hours();
      const minutes = nowIST.minutes();
      const formattedHours = hours.toString().padStart(2, '0');
      const formattedMinutes = minutes.toString().padStart(2, '0');
      timeSlots.push(`${formattedHours}:${formattedMinutes}`);
      nowIST.add(15, 'minutes');
      nowTime.hours = nowIST.hours();
      nowTime.minutes = nowIST.minutes();
    }
    return timeSlots;
  }

  const formatTime2 = (startTime, endTime) => {
    if (!startTime || !endTime) return { start: '00:00', end: '00:00' };
    const formatOptions = { hour: 'numeric', minute: 'numeric', hour12: true };
    const start = new Date(startTime).toLocaleTimeString([], formatOptions);
    const end = new Date(endTime).toLocaleTimeString([], formatOptions);
    return { start, end };
  };

  const { start, end } = formatTime2(
    todayWorkingTime?.startTime,
    todayWorkingTime?.endTime,
  );

  const handleOpenScheduleHoursModal = () => {
    setIsScheduleOpen(true);
    setStartTime('');
    setEndTime('');
  };

  const getNext7Days = () => {
    const today = new Date();
    const dates = [];
    for (let i = 0; i < 8; i++) {
      const date = new Date(today);
      date.setDate(today.getDate() + i);
      dates.push(date);
    }
    return dates;
  };

  const formatDateSelect = date => {
    const options = { day: '2-digit', month: 'short', year: 'numeric' };
    return new Intl.DateTimeFormat('en-GB', options).format(date);
  };

  useEffect(() => {
    const initializaDates = () => {
      const dates = getNext7Days().map(date => ({
        value: date,
        label: formatDateSelect(date),
      }));
      setDateOptions(dates);
      const today = new Date();
      const defaultDate = dates.find(
        option => option.value.toDateString() === today.toDateString(),
      );
      setSelectedDate(defaultDate);
    };
    initializaDates();
  }, []);

  const floorData = async centercode => {
    try {
      const authToken = JSON.parse(localStorage.getItem('headData'))
        ?.spintlyToken;
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}basic-data/get-floor`,
        {
          params: { location: centercode },
          headers: { Authorization: authToken },
        },
      );

      if (response.data.status === 'success') {
        setFloorSpoc(response.data.data);
        if (response.data.data.length > 0) {
          const defaultFloor = {
            value: response.data.data[0]?.rec_id,
            label: response.data.data[0].floor_name,
          };
          setLocation2(defaultFloor);
        }
      }
    } catch (error) {
      console.error('Error fetching floor data:', error);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        let authToken = JSON.parse(localStorage.getItem('headData'));
        const axiosConfig = {
          params: {
            spoc: UserObj.rec_id,
            client: UserObj?.company_id,
          },
          headers: {
            Authorization: `${authToken?.spintlyToken}`,
          },
        };

        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}basic-data/get-location-by-spoc`,
          axiosConfig,
        );

        if (response.data.status === 'success') {
          const formattedData = response.data.data.map(item => ({
            value: item?.rec_id,
            label: item.location_name,
            centercode: item.centercode,
          }));
          setLocationData(formattedData);
        }
      } catch (error) {
        console.error(error);
      }
    };

    const initialize = () => {
      fetchData();
    };
    initialize();
  }, []);

  // Function to update Firebase data
  const updateMap = (key1, obj, data) => {
    Object.keys(data).forEach(key => {
      if (key === key1) {
        data[key] = obj;
      }
    });

    setFirebaseData(data);

    setSelectedDevice(data[selectedDeviceId]);
  };

  // Fetch working times for all locations and selected floor on initial load

  useEffect(() => {
    const fetchWorkingTimes = async () => {
      const localData = JSON.parse(localStorage.getItem('headData'));
      const authToken = localData?.spintlyToken;

      // Fetch selected floor ID from location2 state
      const selectedFloorId = location2 ? [location2.value] : [];
      // Check if floorIds is not empty and locationData has been fetched
      if (selectedFloorId.length > 0 && locationData.length > 0) {
        const feedbackData = {
          locationIds: locationData.map(location => location.value), // Pass all location IDs
          floorIds: selectedFloorId,
        };

        try {
          const res = await axios.post(
            `${process.env.REACT_APP_API_URL}bms/fetch-lcs/${
              UserObj?.company_id
            }`,
            feedbackData,
            {
              headers: { Authorization: authToken },
            },
          );

          if (res.data.status === 200) {
            setFetchLcsData(res.data.data.data);
          }
        } catch (err) {
          console.error('API call error:', err);
        }
      } else {
        console.warn('FloorIds or locationData not available yet.');
      }
    };

    const fetchFirebaseData = async () => {
      if (!firebaseApp) return;
      const db = getDatabase(firebaseApp);
      const dataRef = ref(
        db,
        `${process.env.REACT_APP_FIREBASE_ENV}/LCS/${locationData
          .map(location => location.value)
          .join(',')}/${UserObj?.company_id}`,
      );

      try {
        // Fetch Firebase data for the selected location
        const snapshot = await get(dataRef);
        const data = snapshot.val();
        if (data) {
          setFirebaseData(data);
        }

        // Set up the Firebase listener
        const unsubscribe = onChildChanged(dataRef, snapshot => {
          updateMap(snapshot.key, snapshot.val(), data);
        });

        // Cleanup function for Firebase listener
        return unsubscribe;
      } catch (error) {
        console.error('Error fetching Firebase data:', error);
        return null; // Return null if no unsubscribe function is created
      }
    };

    const initialize = async () => {
      if (locationData.length > 0 && location2 && allLocationStatusTrue) {
        await fetchWorkingTimes(); // Call on initial load
        setAlLocationStatusTrue(false);
      }

      setLoading(true); // Show loader while fetching Firebase data
      const unsubscribe = await fetchFirebaseData(); // Fetch Firebase data and set up listener
      setLoading(false); // Hide loader

      // Return a cleanup function
      return () => {
        if (unsubscribe) unsubscribe(); // Clean up Firebase listener
      };
    };

    // Call the initialize function
    const cleanupFn = initialize();

    return () => {
      if (typeof cleanupFn === 'function') {
        cleanupFn(); // Execute cleanup if it was set
      }
    };
  }, [locationData, location2, allLocationStatusTrue]);

  // Add locationData to the dependency array

  // Handle default location selection
  useEffect(() => {
    if (locationData.length > 0) {
      const defaultLocation = locationData[0];
      changeSelect(defaultLocation);
    }
  }, [locationData]);

  // Change location and fetch relevant Firebase and API data
  const changeSelect = async selectedOption => {
    setSelectedDeviceId(null);
    setLoading(true); // Show loader
    setSelectedLocation(selectedOption);
    setLocationId(selectedOption.value);

    const selectedLocation = locationData.find(
      item => item.value === selectedOption.value,
    );

    const centercode = selectedLocation?.value;

    await floorData(centercode); // Assuming this function fetches floor data based on centercode

    const localData = JSON.parse(localStorage.getItem('headData'));

    const fetchWorkingTimes = async () => {
      const localData = JSON.parse(localStorage.getItem('headData'));
      const authToken = localData?.spintlyToken;

      // Fetch selected floor ID from location2 state
      const selectedFloorId = location2 ? [location2.value] : [];
      // Check if floorIds is not empty and locationData has been fetched
      if (selectedFloorId.length > 0 && locationData.length > 0) {
        const feedbackData = {
          locationIds: [selectedOption.value], // Pass all location IDs
          floorIds: selectedFloorId,
        };

        try {
          const res = await axios.post(
            `${process.env.REACT_APP_API_URL}bms/fetch-lcs/${
              UserObj?.company_id
            }`,
            feedbackData,
            {
              headers: { Authorization: authToken },
            },
          );

          if (res.data.success) {
            setFetchLcsData(res.data.data.data);
          }
        } catch (err) {
          console.error('API call error:', err);
        }
      } else {
        console.warn('FloorIds or locationData not available yet.');
      }
    };

    if (locationData.length > 0 && location2) {
      fetchWorkingTimes(); // Call on initial load
    }

    if (!firebaseApp) return;
    const db = getDatabase(firebaseApp);
    const dataRef = ref(
      db,
      `${process.env.REACT_APP_FIREBASE_ENV}/LCS/${selectedOption.value}/${
        UserObj?.company_id
      }`,
    );

    try {
      // Fetch Firebase data for the selected location
      const snapshot = await get(dataRef);
      const data = snapshot.val();

      if (data) {
        setFirebaseData(data);
      }

      const unsubscribe = onChildChanged(dataRef, snapshot => {
        updateMap(snapshot.key, snapshot.val(), data);
      });

      // Fetch working times based on selected location and floor
      // await fetchWorkingTimes(selectedOption.value, location2?.value, localData?.spintlyToken);

      return () => unsubscribe(); // Clean up listener
    } catch (error) {
      console.error('Error fetching Firebase data:', error);
    } finally {
      setLoading(false); // Hide loader
    }
  };

  // Function to fetch working times
  const fetchWorkingTimes = async (
    selectedLocationId,
    selectedFloorId,
    authToken,
  ) => {
    const feedbackData = {
      locationIds: [selectedLocationId], // Only the selected location
      floorIds: selectedFloorId ? [selectedFloorId] : [], // Selected floor
    };

    try {
      const res = await axios.post(
        `${process.env.REACT_APP_API_URL}bms/fetch-lcs/${UserObj?.company_id}`,
        feedbackData,
        {
          headers: { Authorization: authToken },
        },
      );

      if (res.data.success) {
        setFetchLcsData(res.data.data.data);
      }
    } catch (err) {
      console.error('API call error:', err);
    }
  };

  // Handle floor change
  const handleFloorChange = selectedOption => {
    setLocation2(selectedOption);
    setSelectedDeviceId(''); // Clear selected device when floor changes
    //setSelectedDate(''); // Clear selected date when floor changes

    // Call fetch working times with the new floor selection
    const localData = JSON.parse(localStorage.getItem('headData'));
    if (selectedOption) {
      fetchWorkingTimes(
        locationId,
        selectedOption.value,
        localData?.spintlyToken,
      );
    }
  };

  const customSelectStyles = {
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected ? '#1E1E2D' : '#fff', // Background color for selected option
      '&:hover': {
        backgroundColor: '#323242', // Background color on hover
      },
    }),
  };

  const customSelectLocationStyles = {
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected ? '#1E1E2D' : '#fff', // Background color for selected option
      '&:hover': {
        backgroundColor: '#323242', // Background color on hover
      },
    }),
    menu: provided => ({
      ...provided,
      width: 280, // Set the width of the dropdown menu
    }),
  };

  const handleOtpLightOn = () => {
    const localData = JSON.parse(localStorage.getItem('headData'));
    const body = {
      spocUserId: UserObj?.userId,
      spocName: UserObj?.fname + ' ' + UserObj?.lname,
      spocEmail: UserObj?.email,
      action: 'on-book',
    };
    const authToken = localData?.spintlyToken;
    axios
      .post(
        `${process.env.REACT_APP_API_URL}bms/send-otp/${
          selectedDeviceData._id
        }`,
        body,
        {
          headers: {
            Authorization: authToken,
          },
        },
      )
      .then(res => {
        if (res.data.success === true) {
          setIsOtpSectionVisible(true);
          setIotId(res.data?.data?.data?.requestId);
          toast.success(res.data.message, {});
        } else {
          toast.error(res.data.message, {});
        }
      })
      .catch(error => {
        toast.error(
          'All fields are mandatory. Please share your valuable feedback.',
          {},
        );
      });
  };

  const getBooking = async (iotId, todayWorkingTimeValue) => {
    const localData = JSON.parse(localStorage.getItem('headData'));
    const authToken = localData?.spintlyToken;
    const body = {
      spocName: `${UserObj?.fname} ${UserObj?.lname}`,
      spocUserId: userId,
      spocEmail: UserObj?.email,
    };

    const date = new Date().toLocaleDateString('en-GB').replace(/\//g, '-'); // Format date as dd-mm-yyyy

    try {
      const res = await axios.post(
        `${process.env.REACT_APP_API_URL}bms/get-booking/${iotId}/${moment(
          selectedDate.label,
        ).format('DD-MM-YYYY')}`,
        body,
        {
          headers: {
            Authorization: authToken,
          },
        },
      );

      if (res.data.success === true) {
        const data = res?.data?.data?.data;
        let defaultSchedule = todayWorkingTimeValue;

        defaultSchedule = {
          ...defaultSchedule,
          isDefault: true,
          workingTime: [
            {
              startTime: defaultSchedule?.startTime,
              endTime: defaultSchedule?.endTime,
            },
          ],
        };
        data.push(defaultSchedule);
        data.sort(function(a, b) {
          const keyA = a?.workingTime?.[0]?.startTime;
          const keyB = b?.workingTime?.[0]?.startTime;
          if (keyA < keyB) return -1;
          if (keyA > keyB) return 1;
          return 0;
        });

        const updatedTimeEntries = [
          {
            startTime: todayWorkingTimeValue?.startTime,
            endTime: todayWorkingTimeValue?.endTime,
            type: 'default',
          },
        ];
        data.map(item => {
          if (item.status > 0) {
            updatedTimeEntries.push({
              startTime: item?.workingTime[0].startTime,
              endTime: item?.workingTime[0].endTime,
              type: 'added',
            });
          }
        });

        setTimeEntries(updatedTimeEntries);

        const addedHours = [];
        data.map(item => {
          if (item.status > 0) {
            addedHours.push({
              startTime: item?.workingTime[0].startTime,
              endTime: item?.workingTime[0].endTime,
            });
          }
        });

        setAddedHours(addedHours);

        const sortedorderArray = data.sort((a, b) => {
          // Check if both orders have a valid workingTime and startTime
          const startTimeA = a.workingTime[0]?.startTime;
          const startTimeB = b.workingTime[0]?.startTime;

          if (startTimeA && startTimeB) {
            // Compare the two start times using moment.js
            return moment(startTimeA).diff(moment(startTimeB));
          } else {
            // If either of the orders has no valid startTime, keep their order unchanged
            return 0;
          }
        });

        const filteredArray = data.filter(
          order =>
            order.isDefault === true || order.status == 1 || order.status == 2,
        );

        setData1(filteredArray);

        filteredArray.map(item => {
          const currentTime = moment.tz('Asia/Kolkata').format('HH:mm');
          const scheduleStartTime = moment
            .tz(item?.workingTime[0]?.startTime, 'Asia/Kolkata')
            .format('HH:mm');

          const scheduleEndTime = moment
            .tz(item?.workingTime[0]?.endTime, 'Asia/Kolkata')
            .format('HH:mm');

          // Check if the current time is between startTime and endTime
          const isCurrentTimeInRange =
            currentTime >= scheduleStartTime && currentTime <= scheduleEndTime;

          if (isCurrentTimeInRange) {
            setBookingId(item?._id);
          }
        });

        // Assuming you want to set data2 to the current day's schedule

        // toast.success(res.data.data.message, {
        //
        // });
      } else {
        toast.error(res.data.data.message, {});
      }
    } catch (error) {
      toast.error('An error occurred while fetching booking data.', {});
    }
  };

  //code for single device selection,
  useEffect(() => {
    if (fetchLcsData?.length === 1 && firebaseData) {
      const singleDevice = Object.keys(firebaseData)
        .map(key => {
          const device = firebaseData[key];
          if (
            device.details &&
            fetchLcsData.some(
              lcsDevice =>
                lcsDevice.deviceId === device.details.deviceId.trim(),
            )
          ) {
            return device;
          }
          return null;
        })
        .filter(Boolean)?.[0];

      if (singleDevice) {
        handleDeviceClick(singleDevice);
      }
    }
  }, [fetchLcsData, firebaseData, selectedDate]);
  //code for single device selection,

  const handleDeviceClick = async device => {
    if (!selectedDate) {
      toast.error('Please select a date', {});
      return;
    }
    setEffectiveEndTime(todayWorkingTime?.endTime);
    const data = fetchLcsData?.filter(
      d => d.deviceId === device.details.deviceId.trim(),
    )?.[0];

    setSelectedDeviceData(data);

    let d = selectedDate.value;
    let day = d.getDay();
    if (day === 0) {
      day = 7;
    }
    const workingData = data?.workingTime?.filter(
      d => d.day == day && d.noShow !== true,
    )?.[0];
    const previousDayData = data?.workingTime?.filter(
      d => d.day == day && d.noShow === true && d.previousEndTime != null,
    )?.[0];

    setTodayWorkingTime(workingData);
    setSelectedDeviceId(device.details.deviceId.trim()); //TOT-801
    setSelectedDevice(device);
    setPreviousDayData(previousDayData);

    if (data?._id) {
      getBooking(data?._id, workingData);
    }
  };

  const formatTimeToHHMM = time => {
    if (typeof time === 'string') {
      return time.split(' ')[0];
    } else if (time instanceof Date && !isNaN(time.getTime())) {
      const hours = time.getHours();
      const minutes = time.getMinutes();
      return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(
        2,
        '0',
      )}`;
    } else {
      return '00:00';
    }
  };

  const formatDateToDDMMYYYY = date => {
    if (!(date instanceof Date) || isNaN(date.getTime())) return '';
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

  const handleTurnOn = () => {
    const localData = JSON.parse(localStorage.getItem('headData'));
    const body = {
      spocUserId: userId,
      requestId: String(iotId),
      otp: otp,
      endTime: selectedTime,
    };
    const authToken = localData?.spintlyToken;
    axios
      .post(
        `${process.env.REACT_APP_API_URL}bms/turn-on-and-book/${
          selectedDeviceData._id
        }`,
        body,
        {
          headers: {
            Authorization: authToken,
          },
        },
      )
      .then(res => {
        if (res.data.success === true) {
          setIsOtpSectionVisible(false);
          setIsLightsOpen(false);
          setOtp('');
          toast.success(res.data.message, {});
        } else {
          toast.error(res.data.data.message, {});
          setIsLightsOpen(false);
        }
      })
      .catch(error => {
        console.error(error);
      });

    setIsTogglePowerOn(false);
  };

  const handleOnModal = () => {
    setIsOtpSectionVisible(false);
    setIsDeleteOtpVisible(false);
    if (
      moment.tz('Asia/Kolkata').format('h:mm a') <= start ||
      moment.tz('Asia/Kolkata').format('h:mm a') >= end
    ) {
      setIsLightsOpen(true);
    } else {
      setIsTogglePowerOn(true);
    }
  };

  const handleOffModal = () => {
    setIsOtpSectionVisible(false);
    setIsDeleteOtpVisible(false);
    const currentTimeIST = moment().tz('Asia/Kolkata');
    const formatTimeToHHMM = timeISO => {
      const timeIST = moment.utc(timeISO).tz('Asia/Kolkata'); // Convert to IST
      return timeIST.format('HH:mm');
    };
    const currentTimeFormatted = currentTimeIST.format('HH:mm');
    let isDefaultScheduleActive = false;
    data1?.forEach(item => {
      const startTimeFormatted = formatTimeToHHMM(
        item?.workingTime?.[0]?.startTime,
      );
      const endTimeFormatted = formatTimeToHHMM(
        item?.workingTime?.[0]?.endTime,
      );
      if (
        item.isDefault &&
        currentTimeFormatted >= startTimeFormatted &&
        currentTimeFormatted <= endTimeFormatted
      ) {
        isDefaultScheduleActive = true;
      }
    });

    // If the current time is within the default schedule, toggle power off
    if (isDefaultScheduleActive) {
      setIsTogglePowerOff(true); // Set power off if within default schedule
    } else {
      // If no active default schedule, turn off lights
      setIsLightsOff(true); // Set lights off if not within any default schedule
    }
  };

  const handleScheduleOtp = () => {
    if (
      new Date(endTime).getHours() * 60 + new Date(endTime).getMinutes() <=
      new Date(startTime).getHours() * 60 + new Date(startTime).getMinutes()
    ) {
      toast.error('End time must be greater than start time', {});
      return; // Prevent further execution if times are incorrect
    }
    setOtp('');
    const localData = JSON.parse(localStorage.getItem('headData'));
    const body = {
      spocUserId: userId,
      spocName: `${UserObj?.fname} ${UserObj?.lname}`, // Combine first and last name
      spocEmail: UserObj?.email,
      action: 'create-booking',
    };
    const authToken = localData?.spintlyToken;
    // Ensure deviceIotId is available and then use it in the URL
    axios
      .post(
        `${process.env.REACT_APP_API_URL}bms/send-otp/${
          selectedDeviceData._id
        }`,
        body,
        {
          headers: {
            Authorization: authToken,
          },
        },
      )
      .then(res => {
        if (res.data.success === true) {
          setIsOtpSectionVisible(true);
          setIotId(res?.data?.data?.data?.requestId);
          toast.success(res.data.data.message, {});
          startOtpCountdown();
        } else {
          toast.error(res.data.data.message, {});
        }
      })
      .catch(error => {
        console.error(error);
      });
  };

  const handleToggleOtpOn = () => {
    setOtp('');
    const localData = JSON.parse(localStorage.getItem('headData'));
    const body = {
      spocUserId: userId,
      spocName: `${UserObj?.fname} ${UserObj?.lname}`,
      spocEmail: UserObj?.email,
      action: 'on',
    };
    const authToken = localData?.spintlyToken;
    axios
      .post(
        `${process.env.REACT_APP_API_URL}bms/send-otp/${
          selectedDeviceData._id
        }`,
        body,
        {
          headers: {
            Authorization: authToken,
          },
        },
      )
      .then(res => {
        if (res.data.success === true) {
          setIsOtpSectionVisible(true);
          setIotId(res?.data?.data?.data?.requestId);
          toast.success(res.data.message, {});
          startOtpCountdown(); // Start the countdown timer
        } else {
          toast.error(res.data.data.message, {});
        }
      })
      .catch(error => {
        console.error('Error sending OTP:', error);
      });
  };

  const startOtpCountdown = () => {
    setResendAvailable(false);
    let countdownValue = 60;

    const timer = setInterval(() => {
      countdownValue -= 1;
      setCountdown(countdownValue);

      // Update all countdowns in one state object
      setCountdowns(prev => ({
        ...prev,
        edit: countdownValue,
        delete: countdownValue,
        lightOpen: countdownValue,
        lightOff: countdownValue,
        turnOff: countdownValue,
        turnOn: countdownValue,
      }));

      if (countdownValue <= 0) {
        clearInterval(timer);
        setResendAvailable(true);
      }
    }, 1000);
  };

  const handleResendOTP = () => {
    handleToggleOtpOn();
    startOtpCountdown(); // Restart the countdown after resending OTP
  };

  const handleResendOTP1 = () => {
    handleToggleOtpOff();
    startOtpCountdown(); // Restart the countdown after resending OTP
  };

  const handleResendOTPDelete = () => {
    handleDeleteOtp();
    startOtpCountdown(); // Restart the countdown after resending OTP
  };

  const handleResendOTPSchedule = () => {
    handleScheduleOtp();
    startOtpCountdown();
  };

  const handleToggleOtpOff = () => {
    setOtp('');
    const localData = JSON.parse(localStorage.getItem('headData'));
    const body = {
      spocUserId: userId,
      spocName: `${UserObj?.fname} ${UserObj?.lname}`,
      spocEmail: UserObj?.email,
      action: 'off',
    };
    const authToken = localData?.spintlyToken;
    axios
      .post(
        `${process.env.REACT_APP_API_URL}bms/send-otp/${
          selectedDeviceData._id
        }`,
        body,
        {
          headers: {
            Authorization: authToken,
          },
        },
      )
      .then(res => {
        if (res.data.success === true) {
          setIsOtpSectionVisible(true);
          setIotId(res?.data?.data?.data?.requestId);
          toast.success(res.data.message, {});
          startOtpCountdown(); // Start the countdown timer
        } else {
          toast.error(res.data.data.message, {});
        }
      })
      .catch(error => {
        console.error('Error sending OTP:', error);
      });
  };

  function getEnabledTimes(timeEntity) {
    const { timeArrayStart, timeArrayEnd } = generateTimeArrays();

    const timeToMinutes = time => {
      const [hours, minutes] = time.split(':').map(Number);
      return hours * 60 + minutes;
    };

    const entityRangesStart = timeEntity.map(({ startTime, endTime }) => {
      const start = new Date(startTime);
      const end = new Date(endTime);

      const startMinutes = start.getHours() * 60 + start.getMinutes();
      const endMinutes = end.getHours() * 60 + end.getMinutes();

      // Ensure that endTime is after startTime
      if (endMinutes <= startMinutes) {
        return [startMinutes, 24 * 60 - 1];
      }
      return [startMinutes, endMinutes - 15];
    });

    const entityRangesEnd = timeEntity.map(({ startTime, endTime }) => {
      const start = new Date(startTime);
      const end = new Date(endTime);

      const startMinutes = start.getHours() * 60 + start.getMinutes();
      const endMinutes = end.getHours() * 60 + end.getMinutes();

      if (endMinutes <= startMinutes) {
        return [0, endMinutes];
      }
      return [startMinutes + 15, endMinutes];
    });

    const isEnabledStart = minutes => {
      return !entityRangesStart.some(
        ([start, end]) => minutes >= start && minutes <= end,
      );
    };

    const isEnabledEnd = minutes => {
      if (
        minutes >=
          new Date(startTime).getHours() * 60 +
            new Date(startTime).getMinutes() &&
        minutes <= new Date(endTime).getHours() * 60 + new Date(endTime)
      ) {
        return false;
      }

      return !entityRangesEnd.some(
        ([start, end]) => minutes >= start && minutes <= end,
      );
    };

    let timeArrayStartEnabled = timeArrayStart.filter(time =>
      isEnabledStart(timeToMinutes(time)),
    );

    let timeArrayEndEnabled = timeArrayEnd.filter(time =>
      isEnabledEnd(timeToMinutes(time)),
    );

    let previousEndTime = previousDayData?.previousEndTime;
    if (previousEndTime) {
      previousEndTime = moment(previousEndTime)
        .utcOffset('+05:30')
        .format('HH:mm');
    }

    if (selectedDateValue === currentDateHideShow) {
      const currentTime = moment()
        .utcOffset('+05:30')
        .add(10, 'minutes')
        .format('HH:mm');

      timeArrayStartEnabled = timeArrayStartEnabled.filter(
        time => time > currentTime,
      );
      timeArrayEndEnabled = timeArrayEndEnabled.filter(
        time => time > currentTime,
      );
    }

    if (previousEndTime) {
      timeArrayStartEnabled = timeArrayStartEnabled.filter(
        time => time >= previousEndTime,
      );

      timeArrayEndEnabled = timeArrayEndEnabled.filter(
        time => time > timeArrayStartEnabled,
      );
    }

    if (timeEntity.length !== 0) {
      const firstEntity = timeEntity[0];
      const startTime = new Date(firstEntity.startTime);
      const endTime = new Date(firstEntity.endTime);

      const endMinutes = endTime.getHours() * 60 + endTime.getMinutes();
      const startMinutes = startTime.getHours() * 60 + startTime.getMinutes();

      if (endMinutes < startMinutes) {
        const endMinutesFirst = timeToMinutes(moment(endTime).format('HH:mm'));

        const endTimeFormatted = moment(endTime).format('HH:mm');
        if (timeArrayStartEnabled.includes(endTimeFormatted)) {
          timeArrayStartEnabled.unshift(endTimeFormatted);
        }

        const startMinutesFirst =
          startTime.getHours() * 60 + startTime.getMinutes();
        timeArrayEndEnabled = timeArrayEndEnabled.filter(time => {
          const endMinutes = timeToMinutes(time);
          return (
            endMinutes <= startMinutesFirst &&
            endMinutes !== timeToMinutes(firstEntity.endTime)
          );
        });
      }
    }

    const timeArrayStartWithStatus = timeArrayStart.map(time => ({
      time,
      status: timeArrayStartEnabled.includes(time) ? 'enable' : 'disable',
    }));

    const timeArrayEndWithStatus = timeArrayEnd.map(time => ({
      time,
      status: timeArrayEndEnabled.includes(time) ? 'enable' : 'disable',
    }));

    return { timeArrayStartWithStatus, timeArrayEndWithStatus };
  }

  const { timeArrayStartWithStatus, timeArrayEndWithStatus } = getEnabledTimes(
    timeEntries,
  );

  const handleScheduleVerifyOtp = () => {
    const localData = JSON.parse(localStorage.getItem('headData'));
    const currentDate = formatDateToDDMMYYYY(new Date()); // Current date in DD-MM-YYYY format
    const formattedStartTime = startTime; // No need to convert if startTime is already in HH:mm format
    const formattedEndTime = endTime; // No need to convert if endTime is already in HH:mm format
    const body = {
      spocUserId: userId,
      requestId: String(iotId),
      otp: otp,
      startTime:
        startTime ||
        timeArrayStartWithStatus.find(t => t.status === 'enable').time,
      endTime:
        endTime ||
        newTimeArrayEndWithStatus.find(t => t.status === 'enable').time,
      date: moment(selectedDate?.label).format('DD-MM-YYYY'),
    };
    const authToken = localData?.spintlyToken;
    axios
      .post(
        `${process.env.REACT_APP_API_URL}bms/create-booking/${
          selectedDeviceData._id
        }`,
        body,
        {
          headers: {
            Authorization: authToken,
          },
        },
      )
      .then(res => {
        if (res.data.success === true) {
          setIsScheduleOpen(false);
          setIsOtpSectionVisible(false);

          setIotId(res?.data?.data?.data?.requestId);
          toast.success(res.data.data.message, {});
          getBooking(selectedDeviceData._id, todayWorkingTime);
        } else {
          if (res.data.data.message !== 'Please provide valid otp') {
            setIsOtpSectionVisible(false);
          }
          toast.error(res.data.data.message, {});
        }
      })
      .catch(error => {
        console.error(error);
      });

    setOtp('');

    setIsScheduleHoursModalVisible(false);
  };

  // Delete Hours
  const handleOpenDeleteHoursModal = id => {
    setIsOtpSectionVisible(false);
    setIsDeleteOtpVisible(false);
    setBookingId(id);
    setIsDeleteModalVisible(true);
  };

  const formattedDate = selectedDate
    ? formatDateSelect(selectedDate.value)
    : '';

  const handleCloseDeleteHoursModal = () => {
    setIsDeleteModalVisible(false);
    setIsDeleteOtpVisible(false);
    setIsOtpSectionVisible(false);
  };

  const handleCloseSchedule = () => {
    setIsScheduleOpen(false);
    setIsOtpSectionVisible(false);
    setIsDeleteOtpVisible(false);
  };

  const handleTogglePowerOn = () => {
    const localData = JSON.parse(localStorage.getItem('headData'));
    const currentDate = formatDateToDDMMYYYY(new Date());
    const formattedEffectiveAt = formatTimeToHHMM(effectiveAtOff);
    const body =
      selectedOption === 'on'
        ? { spocUserId: userId, requestId: String(iotId), otp: otp }
        : {
            spocUserId: userId,
            requestId: String(iotId),
            otp: otp,
            effectiveAt: formattedEffectiveAt,
          };

    const authToken = localData?.spintlyToken;
    const url = `${process.env.REACT_APP_API_URL}bms/toggle-power/${
      selectedDeviceData._id
    }/${selectedOption}`;
    axios
      .put(url, body, {
        headers: {
          Authorization: authToken,
        },
      })
      .then(res => {
        if (res.data.success === true) {
          if (firebaseData?.selectedDeviceId) {
            setSelectedDevice(firebaseData?.selectedDeviceId);
          }

          setIsTogglePowerOn(false);
          // setIsOtpSectionVisible(false);
          // setOtp('');
          toast.success(res.data.message, {});
        } else {
          if (res.data.data.message !== 'Please provide valid otp') {
            setIsOtpSectionVisible(false);
          }
          toast.error(res.data.data.message, {});
        }
      })
      .catch(error => {
        console.error('API Error:', error);
      });

    setOtp('');
    // setIsOtpSectionVisible(false);
    // setIsDeleteModalVisible(false);
    setIsScheduleHoursModalVisible(false);
  };

  const handleTogglePowerOff = () => {
    const localData = JSON.parse(localStorage.getItem('headData'));
    const currentDate = formatDateToDDMMYYYY(new Date());
    // Format effectiveAtOff to 24-hour format
    const formattedEffectiveAt = formatTimeTo24Hrs(effectiveAtOff);
    // Construct the body with effectiveAt if selectedOption is 'later'
    const body = {
      spocUserId: userId,
      requestId: String(iotId),
      otp: otp,
      ...(selectedOption === 'later' && { effectiveAt: formattedEffectiveAt }), // Send effectiveAt only if 'later' is selected
    };

    const authToken = localData?.spintlyToken;
    // Always use 'off' in the URL
    const url = `${process.env.REACT_APP_API_URL}bms/toggle-power/${
      selectedDeviceData._id
    }/off`;
    axios
      .put(url, body, {
        headers: {
          Authorization: authToken,
        },
      })
      .then(res => {
        if (res.data.success === true) {
          if (firebaseData?.selectedDeviceId) {
            setSelectedDevice(firebaseData?.selectedDeviceId);
          }
          setIsTogglePowerOff(false);

          toast.success(res.data.message, {});
        } else {
          if (res.data.data.message !== 'Please provide valid otp') {
            setIsOtpSectionVisible(false);
          }
          toast.error(res?.data?.data?.message, {});
        }
      })
      .catch(error => {
        console.error('API Error:', error);
      });

    setOtp('');
    //  setIsOtpSectionVisible(false);
    //  setIsDeleteModalVisible(false);
    setIsScheduleHoursModalVisible(false);
  };

  const handleDeleteOtp = () => {
    setIsDeleteOtpVisible(true);
    setOtp('');
    const localData = JSON.parse(localStorage.getItem('headData'));
    const body = {
      spocUserId: UserObj?.userId,
      spocName: UserObj?.fname + ' ' + UserObj?.lname,
      spocEmail: UserObj?.email,
      action: 'delete-booking',
    };
    const authToken = localData?.spintlyToken;
    axios
      .post(
        `${process.env.REACT_APP_API_URL}bms/send-otp/${
          selectedDeviceData._id
        }`,
        body,
        {
          headers: {
            Authorization: authToken,
          },
        },
      )
      .then(res => {
        if (res.data.success === true) {
          setIsOtpSectionVisible(true);
          setIotId(res.data?.data?.data?.requestId);
          toast.success(res.data.message, {});
          startOtpCountdown();
        } else {
          toast.error(res.data.data.message, {});
        }
      })
      .catch(error => {
        toast.error(
          'All fields are mandatory. Please share your valuable feedback.',
          {},
        );
      });
    // Show OTP section
  };

  const handleDeleteBooking = async () => {
    const localData = JSON.parse(localStorage.getItem('headData'));
    const authToken = localData?.spintlyToken;
    // Ensure this is defined and has the correct value
    // Use bookingId if it's different from iotId

    try {
      const response = await axios.delete(
        `${process.env.REACT_APP_API_URL}bms/cancel-booking/${
          selectedDeviceData._id
        }/${bookingId}`,
        {
          headers: {
            Authorization: authToken,
          },
          data: {
            // Include data as query parameters or in the URL
            spocUserId: userId,
            otp: otp,
            requestId: String(iotId),
          },
        },
      );

      if (response.data.success) {
        toast.success('Booking cancelled successfully', {});
        setIsDeleteModalVisible(false);
        getBooking(selectedDeviceData._id, todayWorkingTime);
      } else {
        console.error('Failed to cancel booking:', response.data.message);
        if (response.data.data.message !== 'Please provide valid otp') {
          setIsDeleteOtpVisible(false);
        }
        toast.error(response.data.data.message, {});
      }
    } catch (error) {
      console.error('API call error:', error);
      toast.error('An error occurred while canceling the booking.', {});
    }
    setOtp('');
    // setIsOtpSectionVisible(false);
    setIsScheduleHoursModalVisible(false);
  };

  const formatTime = (startTime, endTime) => {
    if (!startTime || !endTime) return 'N/A';

    const formatOptions = { hour: 'numeric', minute: 'numeric', hour12: true };
    const start = new Date(startTime);
    const end = new Date(endTime);

    // const startFormatted = start.toLocaleTimeString([], formatOptions);
    // const endFormatted = end.toLocaleTimeString([], formatOptions);
    const startFormatted = start
      .toLocaleTimeString('en-US', formatOptions)
      .replace(' am', ' AM')
      .replace(' pm', ' PM');
    const endFormatted = end
      .toLocaleTimeString('en-US', formatOptions)
      .replace(' am', ' AM')
      .replace(' pm', ' PM');

    // Calculate the difference in milliseconds
    const diffInMs = end - start;
    // Calculate hours and minutes
    const diffInHours = Math.floor(diffInMs / (1000 * 60 * 60));
    const diffInMinutes = Math.floor(
      (diffInMs % (1000 * 60 * 60)) / (1000 * 60),
    );

    return `${startFormatted} - ${endFormatted}`;
  };

  const handleCloseLightOn = () => {
    setIsLightsOpen(false);
  };

  const handleCloseEdit = () => {
    setIsScheduleEdit(false);
    setIsOtpSectionVisible(false);
    setIsDeleteOtpVisible(false);
  };

  const handleCloseTogglePowerOn = () => {
    setIsTogglePowerOn(false);
    setIsOtpSectionVisible(false);
    setIsDeleteOtpVisible(false);
  };

  const handleClosePowerOff = () => {
    setIsLightsOff(false);
    setIsOtpSectionVisible(false);
    setIsDeleteOtpVisible(false);
  };

  const handleOpenEditModal = id => {
    setIsOtpSectionVisible(false);
    setIsDeleteOtpVisible(false);
    const selectedItem = data1.find(item => item._id === id);

    const editTimeEntries = timeEntries.filter(e => {
      return e.startTime != selectedItem.workingTime[0].startTime;
    });
    const editStartEndTimeData = getEnabledTimes(editTimeEntries);
    setEditStartEndTime(editStartEndTimeData);

    setEditStartValue(
      moment
        .tz(selectedItem.workingTime[0]?.startTime, 'Asia/Kolkata')
        .format('HH:mm'),
    );

    setEditEndValue(
      moment
        .tz(selectedItem.workingTime[0]?.endTime, 'Asia/Kolkata')
        .format('HH:mm'),
    );

    if (selectedItem) {
      setBookingId(id); // Set the booking ID for the selected schedule
      setIsScheduleEdit(true); // Open the edit modal
    }
  };

  const handleEffectiveOff = e => {
    setEffectiveAtOff(e.target.value); // Store the selected time in state
  };

  const handleScheduleEditOtp = () => {
    setOtp('');
    const localData = JSON.parse(localStorage.getItem('headData'));
    const body = {
      spocUserId: UserObj?.userId,
      spocName: UserObj?.fname + ' ' + UserObj?.lname,
      spocEmail: UserObj?.email,
      action: 'edit-booking',
    };
    const authToken = localData?.spintlyToken;
    axios
      .post(
        `${process.env.REACT_APP_API_URL}bms/send-otp/${
          selectedDeviceData._id
        }`,
        body,
        {
          headers: {
            Authorization: authToken,
          },
        },
      )
      .then(res => {
        if (res.data.success === true) {
          setIsOtpSectionVisible(true);
          setIotId(res.data.data.data?.requestId);
          toast.success(res.data.message, {});
          startOtpCountdown();
        } else {
          toast.error(res.data.data.message, {});
        }
      })
      .catch(error => {
        toast.error(
          'All fields are mandatory. Please share your valuable feedback.',
          {},
        );
      });
  };

  const handleScheduleEdit = () => {
    const localData = JSON.parse(localStorage.getItem('headData'));
    const currentDate = formatDateToDDMMYYYY(new Date()); // Current date in DD-MM-YYYY format
    // Convert startTime and endTime to Date objects if they are not already
    // Format the start and end times to HH:mm
    const formattedStartTime = startTime; // No need to convert if startTime is already in HH:mm format
    const formattedEndTime = endTime;
    const formattedEffectiveAt = formatTimeTo24Hrs(endTime);

    const body = {
      spocUserId: userId,
      requestId: String(iotId),
      otp: otp,
      endTime:
        editStartValue == '23:45'
          ? '24:00'
          : editEndValue ||
            newTimeArrayEndWithStatus.find(t => t.status === 'enable').time,
      startTime: editStartValue,
    };
    const authToken = localData?.spintlyToken;
    axios
      .put(
        `${process.env.REACT_APP_API_URL}bms/edit-booking/${
          selectedDeviceData._id
        }/${bookingId}`,
        body,
        {
          headers: {
            Authorization: authToken,
          },
        },
      )
      .then(res => {
        if (res.data.success === true) {
          setIsOtpSectionVisible(false);

          setIsScheduleEdit(false);
          setIotId(res.data.data.requestId);
          toast.success(res.data.message, {});
          getBooking(selectedDeviceData._id, todayWorkingTime);
        } else {
          if (res.data.data.message !== 'Please provide valid otp') {
            setIsOtpSectionVisible(false);
          }
          toast.error(res.data.data.message, {});
        }
      })
      .catch(error => {
        console.error(error);
      });

    setOtp('');
    setIsScheduleHoursModalVisible(false);
  };

  const handleCloseTogglePowerOff = () => {
    setIsTogglePowerOff(false);
    setIsOtpSectionVisible(false);
    setIsDeleteOtpVisible(false);
  };

  const handleResendOTPEdit = () => {
    handleScheduleEditOtp();
    startOtpCountdown();
  };

  const handleOtpLightOff = () => {
    const localData = JSON.parse(localStorage.getItem('headData'));
    const body = {
      spocUserId: UserObj?.userId,
      spocName: UserObj?.fname + ' ' + UserObj?.lname,
      spocEmail: UserObj?.email,
      action: 'off-end-booking',
    };
    const authToken = localData?.spintlyToken;
    axios
      .post(
        `${process.env.REACT_APP_API_URL}bms/send-otp/${
          selectedDeviceData._id
        }`,
        body,
        {
          headers: {
            Authorization: authToken,
          },
        },
      )
      .then(res => {
        if (res.data.success === true) {
          setIsOtpSectionVisible(true);
          setIotId(res.data?.data?.data?.requestId);
          toast.success(res.data.message, {});
        } else {
          toast.error(res.data.data.message, {});
        }
      })
      .catch(error => {
        toast.error(
          'All fields are mandatory. Please share your valuable feedback.',
          {},
        );
      });
  };

  const handleTurnOff = id => {
    const localData = JSON.parse(localStorage.getItem('headData'));
    const currentDate = formatDateToDDMMYYYY(new Date()); // Current date in DD-MM-YYYY format
    // Convert startTime and endTime to Date objects if they are not already
    const startDate = new Date(startTime);
    const endDate = new Date(endTime);
    // Format the start and end times to HH:mm
    const formattedStartTime = formatTimeToHHMM(startTime);
    const formattedEndTime = formatTimeToHHMM(endTime);
    const authToken = localData?.spintlyToken;

    if (selectedOption === 'off') {
      // API call for immediate turn off
      const body = {
        spocUserId: userId,
        requestId: String(iotId),
        otp: otp,
      };

      axios
        .put(
          `${process.env.REACT_APP_API_URL}bms/turn-off-and-end-booking/${
            selectedDeviceData._id
          }/${bookingId}`,
          body,
          {
            headers: {
              Authorization: authToken,
            },
          },
        )
        .then(res => {
          if (res.data.success === true) {
            setIsOtpSectionVisible(false);
            setOtp('');
            toast.success(res.data.message, {});
            getBooking(selectedDeviceData._id, todayWorkingTime);
          } else {
            toast.error(res.data.data.message, {});
          }
        })
        .catch(error => {
          console.error(error);
        });
    } else if (selectedOption === 'later') {
      // API call for scheduled turn off
      const body = {
        spocUserId: userId,
        requestId: String(iotId),
        otp: otp,
        endTime: effectiveAtOff,
      };

      axios
        .put(
          `${process.env.REACT_APP_API_URL}bms/edit-booking/${
            selectedDeviceData._id
          }/${bookingId}`,
          body,
          {
            headers: {
              Authorization: authToken,
            },
          },
        )
        .then(res => {
          if (res.data.success === true) {
            setIsOtpSectionVisible(false);
            setOtp('');
            setIsScheduleEdit(false);
            setIotId(res.data.data.requestId);
            toast.success(res.data.message, {});
          } else {
            toast.error(res.data.data.message, {});
          }
        })
        .catch(error => {
          console.error(error);
        });
    }

    // Close modals
    setIsOtpSectionVisible(false);
    setIsScheduleHoursModalVisible(false);
  };

  const handleDateChange = date => {
    setSelectedDate(date);
    setSelectedDeviceId(null); // Reset the selected device when date changes
  };

  function generateTimeArrays() {
    const timeArrayStart = [];
    let timeArrayEnd = [];

    // Generate time in HH:mm format for 24 hours at 15-minute intervals
    for (let hour = 0; hour < 24; hour++) {
      for (let minute = 0; minute < 60; minute += 15) {
        const time = `${hour
          .toString()
          .padStart(2, '0')}:${minute.toString().padStart(2, '0')}`;
        timeArrayStart.push(time);

        // Add 15 minutes to get the end time
        const nextTime = new Date(2001, 0, 1, hour, minute + 15); // Arbitrary date for the time
        const nextTimeStr = `${nextTime
          .getHours()
          .toString()
          .padStart(2, '0')}:${nextTime
          .getMinutes()
          .toString()
          .padStart(2, '0')}`;
        timeArrayEnd.push(nextTimeStr);
      }
    }
    timeArrayEnd = timeArrayEnd.filter(e => e != '00:00');
    timeArrayEnd.push('23:59');
    return { timeArrayStart, timeArrayEnd };
  }

  const convertTo12HourFormat = time => {
    const [hours, minutes] = time.split(':').map(Number);
    const period = hours >= 12 ? 'PM' : 'AM';
    const adjustedHours = hours % 12 || 12; // Convert to 12-hour format, handle midnight as 12
    return `${adjustedHours}:${minutes.toString().padStart(2, '0')} ${period}`;
  };

  function calculateExtraHours(data) {
    const defaultType = 'default';
    const addedType = 'added';

    // Helper function to convert time to a Date object
    function toDate(time) {
      return new Date(time);
    }

    function convertIstToUtc(istDate) {
      // Create a new Date object in IST
      const istDateTime = new Date(istDate);

      // Convert to UTC by adjusting for the offset of IST (UTC+5:30)
      const utcDateTime = new Date(
        istDateTime.getTime() - 5.5 * 60 * 60 * 1000,
      );

      return utcDateTime;
    }

    function formatHoursAndMinutes(hours) {
      const h = Math.floor(hours);
      const m = Math.round((hours - h) * 60);

      if (h === 0 && m === 0) {
        return ''; // Return empty string if both hours and minutes are 0
      }

      if (h === 0) {
        return `${m}m`; // Show only minutes if hours are 0
      }

      if (m === 0) {
        return `${h}hr`; // Show only hours if minutes are 0
      }

      return `${h}hr ${m}m`; // Show both if non-zero
    }

    // Find default working hours
    const defaultHours = data.find(item => item.type === defaultType);
    const startUST = convertIstToUtc(selectedDate?.value);
    const endUST = convertIstToUtc(selectedDate?.value);
    const defaultStart =
      defaultHours?.startTime !== undefined
        ? toDate(defaultHours?.startTime)
        : toDate(startUST);
    const defaultEnd =
      defaultHours?.endTime !== undefined
        ? toDate(defaultHours?.endTime)
        : toDate(endUST);

    // Initialize separate sums for before and after extra hours
    let beforeHours = 0;
    let afterHours = 0;

    // Iterate over added intervals and separate before and after extra hours
    data.forEach(item => {
      if (item.type === addedType) {
        const addedStart = toDate(item.startTime);
        const addedEnd = toDate(item.endTime);

        // Adjust `defaultEnd` to the next day if it is after midnight
        let adjustedDefaultEnd = toDate(defaultEnd);
        if (
          defaultEnd.getHours() < defaultStart.getHours() ||
          defaultEnd.getHours() < 6
        ) {
          adjustedDefaultEnd.setDate(adjustedDefaultEnd.getDate() + 1);
        }

        // Check for extra hours before default working hours
        if (addedEnd <= defaultStart) {
          beforeHours += (addedEnd - addedStart) / (1000 * 60 * 60); // Convert milliseconds to hours
        } else if (addedStart < defaultStart && addedEnd > defaultStart) {
          beforeHours += (defaultStart - addedStart) / (1000 * 60 * 60); // Hours before default hours
        }

        // Check for extra hours after default working hours
        if (addedStart >= adjustedDefaultEnd) {
          afterHours += (addedEnd - addedStart) / (1000 * 60 * 60); // Convert milliseconds to hours
        } else if (
          addedStart < adjustedDefaultEnd &&
          addedEnd > adjustedDefaultEnd
        ) {
          afterHours += (addedEnd - adjustedDefaultEnd) / (1000 * 60 * 60); // Hours after default hours
        }
      }
    });

    // Format hours and only return if non-zero
    const formattedBeforeHours = formatHoursAndMinutes(beforeHours);
    const formattedAfterHours = formatHoursAndMinutes(afterHours);

    return {
      beforeHours: formattedBeforeHours || null,
      afterHours: formattedAfterHours || null,
    };
  }

  const { beforeHours, afterHours } = calculateExtraHours(timeEntries);

  // useEffect(() => {
  //   // Find the first available start time (non-disabled)
  //   const firstAvailableStartTime = timeArrayStartWithStatus.find(({ status }) => status !== 'disable')?.time;

  //   if (firstAvailableStartTime) {
  //     setStartTime(firstAvailableStartTime);

  //     // Find the first end time that is greater than the start time and is not disabled
  //     const firstAvailableEndTime = timeArrayStartWithStatus.find(({ time, status }) =>
  //       time > firstAvailableStartTime && status !== 'disable'
  //     )?.time;

  //     if (firstAvailableEndTime) {
  //       setEndTime(firstAvailableEndTime);
  //     }
  //   }
  // }, [timeArrayStartWithStatus]);

  const onChangeStartTime = e => {
    setStartTime(e.target.value);
  };

  const newTimeArrayEnd = () => {
    let flag = false;
    const op = [];
    timeArrayEndWithStatus.map(da => {
      if (da.status == 'disable') {
        flag = false;
      }
      if (flag && da.status == 'enable') {
        op.push(da);
      }
      if (da.time == startTime) {
        flag = true;
      }
    });
    return op;
  };
  let newTimeArrayEndWithStatus = newTimeArrayEnd();
  if (newTimeArrayEndWithStatus.length == 0) {
    newTimeArrayEndWithStatus = timeArrayEndWithStatus;
  }

  // useEffect(() => {
  //   // Set default startTime and endTime if they are not already set
  //   if (!startTime && timeArrayStartWithStatus.length > 0) {
  //     setStartTime(timeArrayStartWithStatus.find(t => t.status === 'enable')?.time);
  //
  //   }
  //   if (!endTime && timeArrayEndWithStatus.length > 0) {
  //     setEndTime(timeArrayEndWithStatus.find(t => t.status === 'enable')?.time);
  //
  //     if(startTime == "23:45"){
  //         setEndTime('24:00');
  //     }
  //   }
  // }, [timeArrayStartWithStatus, timeArrayEndWithStatus, startTime, endTime]);

  const onChangeEditStart = e => {
    setEditStartValue(e.target.value);
  };

  const newEditEndArray = () => {
    let flag = false;
    const op = [];

    editStartEndTime?.timeArrayEndWithStatus.map(da => {
      if (da.status === 'disable') {
        flag = false;
      }

      // Special case: if the start time is 11:45 p.m., enable 12:00 a.m. even if it's disabled
      if (editStartValue === '23:45' && da.time === '00:00') {
        op.push({
          ...da,
          status: 'enable', // Force enable 12:00 a.m. if 11:45 p.m. is selected
        });
        return op; // Exit early as only 12:00 a.m. should be enabled
      }

      if (flag && da.status === 'enable') {
        op.push(da);
      }

      if (da.time === editStartValue) {
        flag = true;
      }
    });

    return op;
  };

  let newEditEndtime = newEditEndArray();
  if (newEditEndtime.length === 0) {
    newEditEndtime = editStartEndTime?.timeArrayEndWithStatus;
  }

  function generateTimeSlots() {
    const timeSlots = [];
    const currentTime = new Date();
    const currentHours = currentTime.getHours();
    const currentMinutes = currentTime.getMinutes();

    // Get current time and add 15 minutes
    const futureTime = new Date(currentTime.getTime() + 15 * 60000);
    const futureHours = futureTime.getHours();
    const futureMinutes = futureTime.getMinutes();

    // Loop through 24 hours and generate 15-min interval slots
    for (let hour = 0; hour < 24; hour++) {
      for (let minutes = 0; minutes < 60; minutes += 15) {
        const timeString = `${String(hour).padStart(2, '0')}:${String(
          minutes,
        ).padStart(2, '0')}`;

        // Disable times before the futureTime (currentTime + 15 mins)
        const isDisabled =
          hour < futureHours ||
          (hour === futureHours && minutes < futureMinutes);

        timeSlots.push({ time: timeString, disabled: isDisabled });
      }
    }
    return timeSlots;
  }

  useEffect(() => {
    const times = generateTimeSlots();
    setTimeOptions(times);
  }, []);

  // Handle time selection
  const handleTimeChange = event => {
    const selectedValue = event.target.value;
    setSelectedTime(selectedValue);
  };

  function formatTimeString(timeString) {
    return timeString.replace(/\b(am|pm)\b/g, match => match.toUpperCase());
  }

  const updatedOptions = locationData.map(option => ({
    ...option,
    isDisabled: selectedLocation
      ? option.value === selectedLocation.value
      : false,
  }));

  // Create new options array with disabled state
  const updatedDateOptions = dateOptions.map(option => ({
    ...option,
    isDisabled: selectedDate
      ? option.value.toDateString() === selectedDate.value.toDateString()
      : false,
  }));

  // Get current time in IST (Indian Standard Time) format
  const getCurrentTimeInIST = () => {
    return moment()
      .tz('Asia/Kolkata')
      .format('HH:mm a');
  };

  const convertUTCtoISTInHHMM = utcTimestamp => {
    return moment
      .utc(utcTimestamp)
      .tz('Asia/Kolkata')
      .format('hh:mm a');
  };

  const isCurrentTimeBetween = (startTime, endTime) => {
    const currentTime = getCurrentTimeInIST();

    // Convert startTime and endTime from hh:mm a to moment objects
    const startMoment = moment(startTime, 'hh:mm a');
    const endMoment = moment(endTime, 'hh:mm a');
    const currentMoment = moment(currentTime, 'hh:mm a');

    // Check if current time is between startTime and endTime
    return currentMoment.isBetween(startMoment, endMoment, null, '[]'); // Use '[]' for inclusive
  };

  useEffect(() => {
    let isMounted = true; // To track if the component is mounted

    if (data1.length > 0) {
      // Filter the data based on the conditions
      const filteredData = data1
        .filter(item => item.type === 'booking')
        .filter(item => {
          const workingTime = item.workingTime[0];
          const startTime = convertUTCtoISTInHHMM(workingTime.startTime);
          const endTime = convertUTCtoISTInHHMM(workingTime.endTime);

          // Check if current time is between startTime and endTime
          return isCurrentTimeBetween(startTime, endTime);
        });

      if (isMounted) {
        // Set the filtered data in the state
        setFilteredBookingData(filteredData);
      }
    }

    // Cleanup function
    return () => {
      isMounted = false;
    };
  }, [data1]);

  // useEffect(() => {
  //   if (firebaseData) {
  //     const validDevices = Object.keys(firebaseData)
  //       .map(key => firebaseData[key])
  //       .filter(device => device.details && fetchLcsData.some(
  //         lcsDevice => lcsDevice.deviceId === device.details.deviceId
  //       ));

  //     // Automatically select the only device if there is exactly one
  //     if (validDevices.length == 1) {
  //       handleDeviceClick(validDevices[0]);
  //     }
  //   }
  // }, [firebaseData, fetchLcsData, handleDeviceClick]);

  return (
    <Fragment>
      <div className="Dashboard_Card LightGridCard">
        <div className="Dashboard_Card_Header Lightgrid_Card_Header">
          <div className="LightGrid_Header_Left">
            <img src={LightGridIcon} className="LightGridIcon" alt="" />
            <h2>Light grid</h2>
            <Tooltip title="Click for more info">
              <a href="/lightgrid-info" target="_blank" className="LightGridInfoIcon">
                <i class="bi bi-info-circle-fill"></i>
              </a>
            </Tooltip>
          </div>
          <div className="LightGrid_LocationSelector">
            <div className="LightGrid_Location_">
              <span className='me-1'><i class="bi bi-geo-alt-fill"></i></span>
              {/* <Select
                onChange={changeSelect}
                value={selectedLocation}
                options={updatedOptions}
                placeholder="Select Location"
                className="LightGridSelect"
                styles={customSelectLocationStyles}
                isSearchable={true}
              /> */}
              <SwSelect
                onChange={changeSelect}
                value={selectedLocation}
                options={updatedOptions}
                placeholder="Select Location"
                isSearchable
                isClearable={false}
              />
            </div>
            <div>
              {/* <Select
                value={location2}
                onChange={handleFloorChange}
                options={floorSpoc
                  .sort((a, b) => a.business_name.localeCompare(b.floor_name))
                  .map(item => ({
                    value: item?.rec_id,
                    label: item.floor_name,
                  }))}
                placeholder="Floor"
                className="LightGridSelect LightGrid_FloorSelect"
                styles={customSelectStyles}
                isSearchable={false}
              /> */}
              <SwSelect
                value={location2}
                onChange={handleFloorChange}
                options={floorSpoc
                  .sort((a, b) => a.business_name.localeCompare(b.floor_name))
                  .map(item => ({
                    value: item?.rec_id,
                    label: item.floor_name,
                  }))
                }
                placeholder="Floor"
                isSearchable={false}
                isClearable={false}
                className='LCS_Location_Floor_Select'
              />
            </div>
          </div>
        </div>

        <div className="Dashboard_Card_Body">
          <div className="DeviceSelection">
            <div
              className="d-flex align-items-center justify-content-between"
              style={{ marginBottom: '20px' }}
            >
              <h4 className="mb-0">Select a device</h4>
              <div>
                {/* <Select
                  placeholder="Select Date"
                  className="LightGridSelect LightGridSelect_Date"
                  styles={customSelectStyles}
                  options={updatedDateOptions}
                  value={selectedDate}
                  onChange={handleDateChange}
                /> */}
                <SwSelect
                  placeholder="Select Date"
                  options={updatedDateOptions}
                  value={selectedDate}
                  onChange={handleDateChange}
                  isClearable={false}
                />
              </div>
            </div>
            <div className="DeviceSelection_row">
              {firebaseData
                ? Object.keys(firebaseData).map(key => {
                    const device = firebaseData[key];
                    if (!device.details) {
                      return null;
                    }
                    // const matchingLcsDevice = fetchLcsData.find(
                    //   lcsDevice =>
                    //      lcsDevice.deviceId === device.details.deviceId ||
                    //   lcsDevice.deviceId?.trim() === device.details.deviceId?.trim(),
                    // );

                    const matchingLcsDevice = fetchLcsData.find(lcsDevice => {
                      const isMatch =
                        lcsDevice.deviceId?.trim() ===
                        device.details.deviceId?.trim();
                      return isMatch; //TOTO-801
                    });

                    if (!matchingLcsDevice) {
                      return null;
                    }

                    const isSelectedD =
                      selectedDeviceId === device.details.deviceId.trim(); //TOT-801

                    return (
                      <div
                        key={key}
                        className={`Light_DeviceName ${
                          isSelectedD ? 'SelectedDevice' : ''
                        }`}
                        onClick={() => handleDeviceClick(device)}
                      >
                        {matchingLcsDevice?.name}
                      </div>
                    );
                  })
                : ''}
            </div>
          </div>

          {selectedDeviceId?.trim() ? ( //TOT-801
            <div>
              <div className="DeviceSchedule">
                <h4>TODAY’S schedule</h4>
                <div className="DeviceSchedule_row">
                  {/* Map through the schedules for the current day */}
                  <React.Fragment>
                    {/* Display Added Hours Box Before Default Box if schedule is earlier */}
                    {Array.isArray(data1) && data1.length > 0 ? (
                      data1.map(item => {
                        const currentTime = moment
                          .tz('Asia/Kolkata')
                          .format('HH:mm');
                        const scheduleStartTime = moment
                          .tz(item?.workingTime[0]?.startTime, 'Asia/Kolkata')
                          .format('HH:mm');

                        const scheduleEndTime = moment
                          .tz(item?.workingTime[0]?.endTime, 'Asia/Kolkata')
                          .format('HH:mm');

                        // Check if the current time is between startTime and endTime ̰
                        const isCurrentTimeInRange =
                          currentTime >= scheduleStartTime &&
                          currentTime <= scheduleEndTime;

                        return item.isDefault || item.status > 0 ? (
                          <div
                            className={`DeviceSchedule_box ${
                              isCurrentTimeInRange &&
                              selectedDateValue === currentDateHideShow
                                ? 'highlight-blue'
                                : ''
                            }`}
                            key={item?._id}
                            // onClick={() => handleBoxClick(item?._id)}
                          >
                            {/* Only show actions for added hours */}
                            {selectedDateValue === currentDateHideShow
                              ? !item.isDefault &&
                                (moment
                                  .tz(
                                    item.workingTime[0]?.startTime,
                                    'Asia/Kolkata',
                                  )
                                  .format('HH:mm') > currentTime ? (
                                  <div className="DeviceSchedule_Actions">
                                    <a
                                      role="button"
                                      onClick={() =>
                                        handleOpenEditModal(item?._id)
                                      }
                                    >
                                      <img
                                        src="./img/new-dashboard/Edit_Schedule_icon.svg"
                                        alt="Edit"
                                      />
                                    </a>
                                    <a
                                      role="button"
                                      onClick={() =>
                                        handleOpenDeleteHoursModal(item?._id)
                                      }
                                    >
                                      <img
                                        src="./img/new-dashboard/Delete_Schedule_icon.svg"
                                        alt="Delete"
                                      />
                                    </a>
                                  </div>
                                ) : null)
                              : !item.isDefault && (
                                  <div className="DeviceSchedule_Actions">
                                    <a
                                      role="button"
                                      onClick={() =>
                                        handleOpenEditModal(item?._id)
                                      }
                                    >
                                      <img
                                        src="./img/new-dashboard/Edit_Schedule_icon.svg"
                                        alt="Edit"
                                      />
                                    </a>
                                    <a
                                      role="button"
                                      onClick={() =>
                                        handleOpenDeleteHoursModal(item?._id)
                                      }
                                    >
                                      <img
                                        src="./img/new-dashboard/Delete_Schedule_icon.svg"
                                        alt="Delete"
                                      />
                                    </a>
                                  </div>
                                )}

                            {/* Display schedule details */}

                            {item.isDefault == true ? (
                              <>
                                <p>Default Schedule</p>
                                <h2>{`${start.toUpperCase()} - ${end.toUpperCase()}`}</h2>
                              </>
                            ) : (
                              <>
                                <p>Added hours</p>
                                <div>
                                  <h2>
                                    {formatTime(
                                      item?.workingTime?.[0].startTime.toUpperCase(),
                                      item?.workingTime?.[0].endTime.toUpperCase(),
                                    )}
                                  </h2>
                                </div>
                              </>
                            )}
                          </div>
                        ) : (
                          ''
                        );
                      })
                    ) : (
                      <p>No schedules available.</p>
                    )}
                  </React.Fragment>
                </div>

                <div className="LightGrid_Timeline_Container">
                  <div
                    className={`Light_Timeline ${
                      formatTimeString(end) === '11:30 PM' ||
                      formatTimeString(end) === '11:59 PM'
                        ? 'justify-content-end'
                        : ''
                    }`}
                  >
                    <div
                      className={`Prev_Extended_Container ${
                        formatTimeString(start) === '12:00 AM' ||
                        formatTimeString(start) === '1:00 AM'
                          ? 'd-none'
                          : ''
                      }`}
                    >
                      <OverlayTrigger
                        trigger="hover"
                        placement="top"
                        overlay={
                          <Popover className="TimeLine_Popover">
                            <Popover.Body>
                              <div className="PopoverContent_Extended">
                                <img
                                  src="./img/new-dashboard/av_timer.svg"
                                  alt=""
                                />
                                <span>Extended by {beforeHours}</span>
                              </div>
                            </Popover.Body>
                          </Popover>
                        }
                      >
                        <div
                          className={`Extended_Timeline Prev_Extended_Timeline ${
                            beforeHours === null || beforeHours === 0
                              ? 'd-none'
                              : ''
                          }`}
                        >
                          <span>{beforeHours}</span>
                          <div className="TimeLabel">{/* {start} */}</div>
                        </div>
                      </OverlayTrigger>
                    </div>

                    <div
                      className={`Default_Line ${
                        /^[0-9]{1,2}:[0-9]{2} am$/.test(end)
                          ? 'Default_Line_cross'
                          : ''
                      }`}
                    >
                      <div className="Default_Start_Time">
                        {formatTimeString(start)}
                      </div>
                      <div className="Default_End_Time">
                        {formatTimeString(end)}
                      </div>
                    </div>
                    <div
                      className={`Prev_Extended_Container justify-content-start ${
                        formatTimeString(end) === '11:30 PM' ||
                        formatTimeString(end) === '11:59 PM' ||
                        /^[0-9]{1,2}:[0-9]{2} am$/.test(end)
                          ? 'd-none'
                          : ''
                      }`}
                    >
                      <OverlayTrigger
                        trigger="hover"
                        placement="top"
                        overlay={
                          <Popover className="TimeLine_Popover">
                            <Popover.Body>
                              <div className="PopoverContent_Extended">
                                <img
                                  src="./img/new-dashboard/av_timer.svg"
                                  alt=""
                                />
                                <span>Extended by {afterHours}</span>
                              </div>
                            </Popover.Body>
                          </Popover>
                        }
                      >
                        <div
                          className={`Extended_Timeline ${
                            afterHours !== null && afterHours !== 0
                              ? ''
                              : 'd-none'
                          }`}
                        >
                          <span>{afterHours}</span>
                          <div className="TimeLabel">{/* {end} */}</div>
                        </div>
                      </OverlayTrigger>
                    </div>

                    <div
                      className={`Timeline_Start_Time  ${
                        formatTimeString(start) === '12:00 AM' ||
                        formatTimeString(start) === '1:00 AM' ||
                        /^[0-9]{1,2}:[0-9]{2} am$/.test(end)
                          ? 'd-none'
                          : ''
                      }`}
                    >
                      12AM
                    </div>
                    <div
                      className={`Timeline_End_Time  ${
                        formatTimeString(end) === '11:30 PM' ||
                        formatTimeString(end) === '11:59 PM' ||
                        /^[0-9]{1,2}:[0-9]{2} am$/.test(end)
                          ? 'd-none'
                          : ''
                      }`}
                    >
                      12AM
                    </div>
                  </div>
                  {/* ),
                      )
                    ) : (
                      <p>No schedules available.</p>
                    )} */}
                </div>
              </div>

              {moment(selectedDateValue, 'DD/MM/YYYY').isAfter(
                moment(),
                'day',
              ) ? (
                <div className="LightCurrentStatus_Section">
                  <h4>current status</h4>
                  <div className="d-flex">
                    <div className="LightGridArea">
                      <OverlayTrigger
                        trigger="hover"
                        placement="top"
                        overlay={
                          <Popover
                            id="popover-basic"
                            className="LightStatus-popover"
                          >
                            <Popover.Header
                              as="div"
                              className="PopoverStatus Off"
                            >
                              "Off"
                            </Popover.Header>
                            <Popover.Body className="PopoverDetails">
                              <div className="PopoverDetailsRow">
                                <img src={deviceIconWhite} alt="Center Icon" />
                                <div>
                                  {
                                    firebaseData[selectedDeviceId].details
                                      ?.center
                                  }
                                </div>
                              </div>
                              <div className="PopoverDetailsRow">
                                <img src={buldingIconWhite} alt="Device Icon" />
                                <div>
                                  {
                                    firebaseData[selectedDeviceId].details
                                      ?.deviceName
                                  }
                                </div>
                              </div>
                            </Popover.Body>
                          </Popover>
                        }
                      >
                        <div className="LightGridArea_StatusBx OffSts" />
                      </OverlayTrigger>
                      {/* Display selectedDeviceName if it exists */}

                      <div className="LightGridArea_Name OffSts">
                        {firebaseData[selectedDeviceId].details?.deviceName}
                      </div>
                    </div>
                  </div>

                  <div className="LightCurrentStatus_Notes">Light is OFF.</div>
                </div>
              ) : (
                <div className="LightCurrentStatus_Section">
                  <h4>current status</h4>
                  <div className="d-flex">
                    <div className="LightGridArea">
                      <OverlayTrigger
                        trigger="hover"
                        placement="top"
                        overlay={
                          <Popover
                            id="popover-basic"
                            className="LightStatus-popover"
                          >
                            <Popover.Header
                              as="div"
                              className={`PopoverStatus ${
                                firebaseData[selectedDeviceId].state
                                  ?.isOnline &&
                                firebaseData[selectedDeviceId].powerData?.power
                                  ? 'On'
                                  : firebaseData[selectedDeviceId].state
                                      ?.isOnline &&
                                    !firebaseData[selectedDeviceId].powerData
                                      ?.power
                                  ? 'Off'
                                  : 'Disconnected'
                              }`}
                            >
                              {firebaseData[selectedDeviceId].state?.isOnline &&
                              firebaseData[selectedDeviceId].powerData?.power
                                ? 'On'
                                : firebaseData[selectedDeviceId].state
                                    ?.isOnline &&
                                  !firebaseData[selectedDeviceId].powerData
                                    ?.power
                                ? 'Off'
                                : 'Disconnected'}
                            </Popover.Header>
                            <Popover.Body className="PopoverDetails">
                              <div className="PopoverDetailsRow">
                                <img src={deviceIconWhite} alt="Center Icon" />
                                <div>
                                  {
                                    firebaseData[selectedDeviceId].details
                                      ?.center
                                  }
                                </div>
                              </div>
                              <div className="PopoverDetailsRow">
                                <img src={buldingIconWhite} alt="Device Icon" />
                                <div>
                                  {
                                    firebaseData[selectedDeviceId].details
                                      ?.deviceName
                                  }
                                </div>
                              </div>
                            </Popover.Body>
                          </Popover>
                        }
                      >
                        <div
                          className={`LightGridArea_StatusBx ${
                            firebaseData[selectedDeviceId].state?.isOnline &&
                            firebaseData[selectedDeviceId].powerData?.power
                              ? 'OnSts'
                              : firebaseData[selectedDeviceId].state
                                  ?.isOnline &&
                                !firebaseData[selectedDeviceId].powerData?.power
                              ? 'OffSts'
                              : 'DisconnectedSts'
                          }`}
                        />
                      </OverlayTrigger>
                      {/* Display selectedDeviceName if it exists */}

                      <div
                        className={`LightGridArea_Name ${
                          firebaseData[selectedDeviceId].state?.isOnline &&
                          firebaseData[selectedDeviceId].powerData?.power
                            ? 'OnSts'
                            : firebaseData[selectedDeviceId].state?.isOnline &&
                              !firebaseData[selectedDeviceId].details
                                ?.deviceName
                            ? 'OffSts'
                            : 'DisconnectedSts'
                        }`}
                      >
                        {firebaseData[selectedDeviceId].details?.deviceName}
                      </div>
                    </div>
                  </div>

                  {firebaseData[selectedDeviceId].state?.isOnline &&
                  firebaseData[selectedDeviceId].powerData?.power ? (
                    <div className="LightCurrentStatus_Notes">
                      Light is ON.
                      {/* It will be switched off today at {moment(data1[data1.length - 1]?.workingTime[0]?.endTime).format('hh:mm A')} */}
                    </div>
                  ) : firebaseData[selectedDeviceId].state?.isOnline &&
                    !firebaseData[selectedDeviceId].powerData?.power ? (
                    <div className="LightCurrentStatus_Notes">
                      Light is OFF.
                      {/* It will be switched on today at {moment(data1[data1.length - 1]?.workingTime[0]?.endTime).format('hh:mm A')} */}
                    </div>
                  ) : (
                    <div className="LightCurrentStatus_Notes">
                      Light is disconnected. Please contact your admin.
                    </div>
                  )}
                </div>
              )}

              <div className="LightGridCard_Footer">
                <div className="LightGridCard_Footer_Btns">
                  <button
                    className="btn"
                    onClick={handleOpenScheduleHoursModal}
                    disabled={!firebaseData[selectedDeviceId]?.state?.isOnline}
                  >
                    Schedule New Hours
                  </button>

                  {selectedDateValue === currentDateHideShow ? (
                    !firebaseData[selectedDeviceId].state?.isOnline ? (
                      <button
                        className="btn TrnOnLight_Btn"
                        onClick={handleOnModal}
                        disabled={
                          !firebaseData[selectedDeviceId]?.state?.isOnline
                        }
                      >
                        Turn ON Lights
                      </button>
                    ) : !firebaseData[selectedDeviceId].powerData?.power ? (
                      <button
                        className="btn TrnOnLight_Btn"
                        onClick={handleOnModal}
                        disabled={filteredBookingData.length > 0}
                      >
                        Turn ON Lights
                      </button>
                    ) : (
                      <button
                        className="btn TrnOnLight_Btn"
                        onClick={handleOffModal}
                      >
                        Turn Off Lights
                      </button>
                    )
                  ) : null // Show nothing if the date doesn't match
                  }
                </div>
              </div>
            </div>
          ) : fetchLcsData && fetchLcsData.length > 0 ? (
            <div className="SelectDeviceImage">
              <img src={SelectDeviceImage} alt="" />
            </div>
          ) : (
            <div className="SelectDeviceImage">
              <img src={NoDataImage} alt="" />
            </div>
          )}
        </div>

        {/* LightGrid Schedule Light On  Modal */}
        {isLightsOpen && (
          <div className="LightGridModal">
            <div className="LightGridModal_Section">
              <div className="CloseModal" onClick={handleCloseLightOn}>
                <img src={CloseModalcon} alt="Close Modal" />
              </div>
              {!isOtpSectionVisible ? (
                <>
                  <div className="LightGridModal_Body">
                    <h4>Are you sure want to turn ON lights ?</h4>
                    <div className="LightGridModal_Content">
                      <div className="ScheduleHoursModalContent">
                        <div className="ScheduleHoursModal_row">
                          <div className="ScheduleHoursModal_Day">
                            {' '}
                            <span>Date</span> - {formattedDate}
                          </div>
                        </div>
                        <div className="ScheduleHoursModal_row">
                          <div className="ScheduleHoursModal_Col">
                            <label>End Time</label>
                            <select
                              className="form-control"
                              onChange={handleTimeChange}
                              value={selectedTime}
                            >
                              {timeOptions.map((option, index) => (
                                <option
                                  key={index}
                                  value={option.time}
                                  disabled={option.disabled}
                                >
                                  {convertTo12HourFormat(option.time)}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="LightGridModal_Footer">
                    <div className="d-block">
                      <button
                        className="btn LightGridModal_CTA CTA-Dark btn-block mr-0"
                        onClick={handleOtpLightOn}
                      >
                        Continue
                      </button>
                    </div>
                  </div>
                </>
              ) : (
                <>
                  <div className="LightGridModal_Body">
                    <h4>Enter OTP sent to your official email id</h4>
                    <div className="LightGridModal_Content">
                      <div className="OTP_Input_Container">
                        <OtpInput
                          value={otp}
                          onChange={setOtp}
                          numInputs={6}
                          isInputNum="true"
                          renderSeparator={''}
                          inputStyle="OTPInputs"
                          renderInput={props => <input {...props} />}
                        />
                        <p>
                          {resendAvailable ? (
                            <a
                              role="button"
                              className="link"
                              onClick={handleResendOTP}
                            >
                              Resend OTP
                            </a>
                          ) : (
                            `Didn’t receive a code? Resend OTP in ${
                              countdowns.lightOpen
                            } seconds`
                          )}
                        </p>
                      </div>
                    </div>
                  </div>

                  <div className="LightGridModal_Footer">
                    <div className="d-block">
                      <button
                        className="btn LightGridModal_CTA CTA-Dark btn-block mr-0"
                        onClick={handleTurnOn}
                      >
                        Verify
                      </button>
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
        )}
        {isLightsOff && (
          <div className="LightGridModal">
            <div className="LightGridModal_Section">
              <div className="CloseModal" onClick={handleClosePowerOff}>
                <img src={CloseModalcon} alt="Close Modal" />
              </div>
              {!isOtpSectionVisible ? (
                <>
                  <div className="LightGridModal_Body">
                    <h4>Do you want to turn OFF lights immediately ?</h4>
                    <div className="LightGridModal_Content">
                      <div className="ScheduleHoursModalContent">
                        <div className="ScheduleHoursModal_row">
                          <Form.Check
                            type="radio"
                            label="Turn Off Now"
                            name="LCSOffoptions"
                            value="off"
                            id="LcsOffRadio"
                            checked={selectedOption === 'off'}
                            onChange={e => setSelectedOption(e.target.value)}
                          />
                        </div>

                        <div className="ScheduleHoursModal_row">
                          <div class="ScheduleHoursModal_Day">
                            <span>Date</span> - {formattedDate}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="LightGridModal_Footer">
                    <div className="d-block">
                      <button
                        className="btn LightGridModal_CTA CTA-Dark btn-block mr-0"
                        onClick={handleOtpLightOff} //handleOtpLightOff
                      >
                        Continue
                      </button>
                    </div>
                  </div>
                </>
              ) : (
                <>
                  <div className="LightGridModal_Body">
                    <h4>Enter OTP sent to your official email id </h4>
                    <div className="LightGridModal_Content">
                      <div className="OTP_Input_Container">
                        <OtpInput
                          value={otp}
                          onChange={setOtp}
                          numInputs={6}
                          isInputNum="true"
                          renderSeparator={''}
                          inputStyle="OTPInputs"
                          renderInput={props => <input {...props} />}
                        />
                        <p>
                          {resendAvailable ? (
                            <a
                              role="button"
                              className="link"
                              onClick={handleResendOTP1}
                            >
                              Resend OTP
                            </a>
                          ) : (
                            `Didn’t receive a code? Resend OTP in ${
                              countdowns.lightOff
                            } seconds`
                          )}
                        </p>
                      </div>
                    </div>
                  </div>

                  <div className="LightGridModal_Footer">
                    <div className="d-block">
                      <button
                        className="btn LightGridModal_CTA CTA-Dark btn-block mr-0"
                        onClick={handleTurnOff}
                      >
                        Verify
                      </button>
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
        )}

        {/* LightGrid Schedule Hours Modal */}
        {isScheduleOpen && (
          <div className="LightGridModal">
            <div className="LightGridModal_Section">
              <div className="CloseModal" onClick={handleCloseSchedule}>
                <img src={CloseModalcon} alt="Close Modal" />
              </div>
              {!isOtpSectionVisible ? (
                <>
                  <div className="LightGridModal_Body">
                    <h4>Are you sure you want to schedule new hours?</h4>
                    <div className="LightGridModal_Content">
                      <div className="ScheduleHoursModalContent">
                        <div className="ScheduleHoursModal_row">
                          <div className="ScheduleHoursModal_Day">
                            {' '}
                            <span>Date</span> - {formattedDate}
                          </div>
                        </div>
                        <div className="ScheduleHoursModal_row">
                          <div className="ScheduleHoursModal_Col">
                            <label>Start Time</label>
                            <select
                              className="form-control"
                              value={startTime}
                              onChange={onChangeStartTime}
                            >
                              {timeArrayStartWithStatus.map(
                                ({ time, status }) => (
                                  <option
                                    key={time}
                                    value={time}
                                    disabled={status === 'disable'}
                                  >
                                    {convertTo12HourFormat(time)}{' '}
                                    {status === 'disable'}
                                  </option>
                                ),
                              )}
                            </select>
                          </div>
                          <div className="ScheduleHoursModal_Col">
                            <label>End Time</label>
                            <select
                              className="form-control"
                              value={endTime}
                              onChange={e => setEndTime(e.target.value)}
                            >
                              {newTimeArrayEndWithStatus.map(
                                ({ time, status }) => (
                                  <option
                                    key={time}
                                    value={time}
                                    disabled={status === 'disable'}
                                  >
                                    {convertTo12HourFormat(time)}{' '}
                                    {status === 'disable'}
                                  </option>
                                ),
                              )}
                            </select>
                          </div>
                        </div>
                        {/* <div className="ScheduleHoursModal_row">
                          <i>Note: Additional charges will be applicable</i>
                        </div> */}
                      </div>
                    </div>
                  </div>

                  <div className="LightGridModal_Footer">
                    <div className="d-block">
                      <button
                        className="btn LightGridModal_CTA CTA-Dark btn-block mr-0"
                        onClick={handleScheduleOtp}
                      >
                        Continue
                      </button>
                    </div>
                  </div>
                </>
              ) : (
                <>
                  <div className="LightGridModal_Body">
                    <h4>Enter OTP sent to your official email id </h4>
                    <div className="LightGridModal_Content">
                      <div className="OTP_Input_Container">
                        <OtpInput
                          value={otp}
                          onChange={setOtp}
                          numInputs={6}
                          isInputNum="true"
                          renderSeparator={''}
                          inputStyle="OTPInputs"
                          renderInput={props => <input {...props} />}
                        />
                        <p>
                          {resendAvailable ? (
                            <a
                              role="button"
                              className="link"
                              onClick={handleResendOTPSchedule}
                            >
                              Resend OTP
                            </a>
                          ) : (
                            `Didn’t receive a code? Resend OTP in ${countdown} seconds`
                          )}
                        </p>
                      </div>
                    </div>
                  </div>

                  <div className="LightGridModal_Footer">
                    <div className="d-block">
                      <button
                        className="btn LightGridModal_CTA CTA-Dark btn-block mr-0"
                        onClick={handleScheduleVerifyOtp}
                      >
                        Verify
                      </button>
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
        )}

        {/* LightGrid Schedule toggle power on  now and later */}

        {isTogglePowerOn && (
          <div className="LightGridModal">
            <div className="LightGridModal_Section">
              <div className="CloseModal" onClick={handleCloseTogglePowerOn}>
                <img src={CloseModalcon} alt="Close Modal" />
              </div>
              {!isOtpSectionVisible ? (
                <>
                  <div className="LightGridModal_Body">
                    <h4>Do you want to turn ON lights immediately ?</h4>
                    <div className="LightGridModal_Content">
                      <div className="ScheduleHoursModalContent">
                        <div className="ScheduleHoursModal_row">
                          <div>
                            <Form.Check
                              type="radio"
                              label="Turn On Now"
                              name="LCSOffoptions"
                              value="on"
                              id="LcsOffRadio"
                              checked={selectedOption === 'on'}
                              onChange={e => setSelectedOption(e.target.value)}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="LightGridModal_Footer">
                    <div className="d-block">
                      <button
                        className="btn LightGridModal_CTA CTA-Dark btn-block mr-0"
                        onClick={handleToggleOtpOn}
                      >
                        Continue
                      </button>
                    </div>
                  </div>
                </>
              ) : (
                <>
                  <div className="LightGridModal_Body">
                    <h4>Enter OTP sent to your official email id </h4>
                    <div className="LightGridModal_Content">
                      <div className="OTP_Input_Container">
                        <OtpInput
                          value={otp}
                          onChange={setOtp}
                          numInputs={6}
                          isInputNum={true}
                          renderSeparator={''}
                          inputStyle="OTPInputs"
                          renderInput={props => <input {...props} />}
                        />
                        <p>
                          {resendAvailable ? (
                            <a
                              role="button"
                              className="link"
                              onClick={handleResendOTP}
                            >
                              Resend OTP
                            </a>
                          ) : (
                            `Didn’t receive a code? Resend OTP in ${
                              countdowns.turnOn
                            } seconds`
                          )}
                        </p>
                      </div>
                    </div>
                  </div>

                  <div className="LightGridModal_Footer">
                    <div className="d-block">
                      <button
                        className="btn LightGridModal_CTA CTA-Dark btn-block mr-0"
                        onClick={handleTogglePowerOn}
                      >
                        Verify
                      </button>
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
        )}

        {/* LightGrid Schedule toggle power off  now and later */}
        {isTogglePowerOff && (
          <div className="LightGridModal">
            <div className="LightGridModal_Section">
              <div className="CloseModal" onClick={handleCloseTogglePowerOff}>
                <img src={CloseModalcon} alt="Close Modal" />
              </div>
              {!isOtpSectionVisible ? (
                <>
                  <div className="LightGridModal_Body">
                    <h4>Do you want to turn OFF lights immediately ?</h4>
                    <div className="LightGridModal_Content">
                      <div className="ScheduleHoursModalContent">
                        <div className="ScheduleHoursModal_row">
                          <Form.Check
                            type="radio"
                            label="Turn Off Now"
                            name="LCSOffoptions"
                            value="off"
                            id="LcsOffRadio"
                            checked={selectedOption === 'off'}
                            onChange={e => setSelectedOption(e.target.value)}
                          />
                        </div>

                        <div className="ScheduleHoursModal_row">
                          <div class="ScheduleHoursModal_Day">
                            <span>Date</span> - {formattedDate}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="LightGridModal_Footer">
                    <div className="d-block">
                      <button
                        className="btn LightGridModal_CTA CTA-Dark btn-block mr-0"
                        onClick={handleToggleOtpOff}
                      >
                        Continue
                      </button>
                    </div>
                  </div>
                </>
              ) : (
                <>
                  <div className="LightGridModal_Body">
                    <h4>Enter OTP sent to your official email id </h4>
                    <div className="LightGridModal_Content">
                      <div className="OTP_Input_Container">
                        <OtpInput
                          value={otp}
                          onChange={setOtp}
                          numInputs={6}
                          isInputNum="true"
                          renderSeparator={''}
                          inputStyle="OTPInputs"
                          renderInput={props => <input {...props} />}
                        />
                        <p>
                          {resendAvailable ? (
                            <a
                              role="button"
                              className="link"
                              onClick={handleResendOTP1}
                            >
                              Resend OTP
                            </a>
                          ) : (
                            `Didn’t receive a code? Resend OTP in ${
                              countdowns.turnOff
                            } seconds`
                          )}
                        </p>
                      </div>
                    </div>
                  </div>

                  <div className="LightGridModal_Footer">
                    <div className="d-block">
                      <button
                        className="btn LightGridModal_CTA CTA-Dark btn-block mr-0"
                        onClick={handleTogglePowerOff}
                      >
                        Verify
                      </button>
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
        )}

        {isDeleteModalVisible && (
          <div className="LightGridModal">
            <div className="LightGridModal_Section">
              <div className="CloseModal" onClick={handleCloseDeleteHoursModal}>
                <img src={CloseModalcon} alt="Close Modal" />
              </div>

              {!isDeleteOtpVisible ? (
                <>
                  <div className="LightGridModal_Body pb-0">
                    <h4 className="text-center">
                      Do you want to cancel these added hours?
                    </h4>
                  </div>

                  <div className="LightGridModal_Footer">
                    <div className="d-flex justify-content-center">
                      <button
                        className="btn LightGridModal_CTA CTA-Dark"
                        onClick={handleDeleteOtp}
                      >
                        Yes
                      </button>
                      <button
                        className="btn LightGridModal_CTA CTA-Lite mr-0"
                        onClick={handleCloseDeleteHoursModal}
                      >
                        No
                      </button>
                    </div>
                  </div>
                </>
              ) : (
                <>
                  <div className="LightGridModal_Body">
                    <h4>Enter OTP sent to your official email id</h4>
                    <div className="LightGridModal_Content">
                      <div className="OTP_Input_Container">
                        <OtpInput
                          value={otp}
                          onChange={setOtp}
                          numInputs={6}
                          isInputNum="true"
                          renderSeparator={''}
                          inputStyle="OTPInputs"
                          renderInput={props => <input {...props} />}
                        />
                        <p>
                          {resendAvailable ? (
                            <a
                              role="button"
                              className="link"
                              onClick={handleResendOTPDelete}
                            >
                              Resend OTP
                            </a>
                          ) : (
                            `Didn’t receive a code? Resend OTP in ${
                              countdowns.delete
                            } seconds`
                          )}
                        </p>
                      </div>
                    </div>
                  </div>

                  <div className="LightGridModal_Footer">
                    <div className="d-block">
                      <button
                        className="btn LightGridModal_CTA CTA-Dark btn-block mr-0"
                        onClick={handleDeleteBooking}
                      >
                        Verify
                      </button>
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
        )}

        {isScheduleEdit && (
          <div className="LightGridModal">
            <div className="LightGridModal_Section">
              <div className="CloseModal" onClick={handleCloseEdit}>
                <img src={CloseModalcon} alt="Close Modal" />
              </div>
              {!isOtpSectionVisible ? (
                <>
                  <div className="LightGridModal_Body">
                    <h4>Are you sure want to edit lights ? </h4>
                    <div className="LightGridModal_Content">
                      <div className="ScheduleHoursModalContent">
                        <div className="ScheduleHoursModal_row">
                          <div className="ScheduleHoursModal_Day">
                            {' '}
                            <span>Date</span> - {formattedDate}
                          </div>
                        </div>
                        <div className="ScheduleHoursModal_row">
                          <div className="ScheduleHoursModal_Col">
                            <label>Start Time</label>
                            <select
                              className="form-control"
                              value={editStartValue}
                              //onChange={e => setStartTime(e.target.value)}
                              onChange={onChangeEditStart}
                            >
                              {editStartEndTime.timeArrayStartWithStatus.map(
                                option => (
                                  <option
                                    key={option.time}
                                    value={option.time}
                                    disabled={option.status === 'disable'}
                                  >
                                    {convertTo12HourFormat(option.time)}
                                  </option>
                                ),
                              )}
                            </select>
                          </div>
                          <div className="ScheduleHoursModal_Col">
                            <label>End Time</label>
                            <select
                              className="form-control"
                              value={editEndValue}
                              onChange={e => setEditEndValue(e.target.value)}
                            >
                              {newEditEndtime.map(option => (
                                <option
                                  key={option.time}
                                  value={option.time}
                                  disabled={option.status === 'disable'}
                                >
                                  {convertTo12HourFormat(option.time)}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>
                        {/* <div className='ScheduleHoursModal_row'>
                                                    <i>Note: Additional charges will be applicable</i>
                                                </div> */}
                      </div>
                    </div>
                  </div>

                  <div className="LightGridModal_Footer">
                    <div className="d-block">
                      <button
                        className="btn LightGridModal_CTA CTA-Dark btn-block mr-0"
                        onClick={handleScheduleEditOtp}
                      >
                        Continue
                      </button>
                    </div>
                  </div>
                </>
              ) : (
                <>
                  <div className="LightGridModal_Body">
                    <h4>Enter OTP sent to your official email id</h4>
                    <div className="LightGridModal_Content">
                      <div className="OTP_Input_Container">
                        <OtpInput
                          value={otp}
                          onChange={setOtp}
                          numInputs={6}
                          isInputNum="true"
                          renderSeparator={''}
                          inputStyle="OTPInputs"
                          renderInput={props => <input {...props} />}
                        />
                        <p>
                          {resendAvailable ? (
                            <a
                              role="button"
                              className="link"
                              onClick={handleResendOTPEdit}
                            >
                              Resend OTP
                            </a>
                          ) : (
                            `Didn’t receive a code? Resend OTP in ${
                              countdowns.edit
                            } seconds`
                          )}
                        </p>
                      </div>
                    </div>
                  </div>

                  <div className="LightGridModal_Footer">
                    <div className="d-block">
                      <button
                        className="btn LightGridModal_CTA CTA-Dark btn-block mr-0"
                        onClick={handleScheduleEdit}
                      >
                        Verify
                      </button>
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
        )}
      </div>
    </Fragment>
  );
}

export default connect()(LightGrid);
